import ReactDOM from 'react-dom';
import RatingComponent from './RatingComponent';
import { RatingPromptProps } from './index';

const RatingComponentWithPortal = (props: RatingPromptProps) => {
    return ReactDOM.createPortal(<RatingComponent {...props} />, document.body);
};

export default RatingComponentWithPortal;
